import React from 'react';

export const ValidationSummary = () => {
  return <div>ValidationSummary</div>;
};
